<template>
	<div :class="$style['grid']">
		<slot />
	</div>
</template>
<script>
export default {
	name: 'Grid'
}
</script>
<style lang="scss" module>

	.grid {
		display: flex;
		flex-wrap: wrap;
		// justify-content: space-between;
		margin: 0 -#{$gutter * 1.25};
		-webkit-overflow-scrolling: touch;
	}
</style>
